import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class PackageService extends RestfulService<Models.Package> {

  constructor(private restService: RestService) {
    super(Models.Package);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('packages');
  }

}
